import {
  COMPANIES_CHANGE_ACTIVE_FILTER_STATUS,
  COMPANIES_CREATE,
  COMPANIES_EDIT,
  COMPANIES_ERROR,
  COMPANIES_FETCHING_DATA,
  COMPANIES_GET_NEW_DATA,
  COMPANIES_INDEX,
  COMPANIES_SHOW,
  COMPANY_CREATE_CONTACT,
  COMPANY_EDIT_CONTACT,
  COMPANY_GET_CONTACTS,
  COMPANY_DELETE_CONTACTS,
  COMPANY_GET_PROJECTS,
} from "../../typesAction";

const INITIAL_STATE = {
  companies: [],
  errorMessage: null,
  inProgress: false,
  totalItems: 0,
  filters: [],
  currentCompany: {},
  contacts: {},
  projects: {
    "hydra:member": [],
    "hydra:totalItems": 0,
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case COMPANY_GET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };
    case COMPANIES_INDEX:
      return {
        ...state,
        filters: action.payload.filters,
        companies: action.payload.data["hydra:member"],
        totalItems: action.payload.data["hydra:totalItems"],
        errorMessage: null,
        inProgress: false,
      };
    case COMPANIES_GET_NEW_DATA:
      return {
        ...state,
        companies: action.payload["hydra:member"],
        totalItems: action.payload["hydra:totalItems"],
        errorMessage: null,
        inProgress: false,
      };
    case COMPANIES_ERROR:
      return {
        ...state,
        errorMessage: action.payload.response.data,
        inProgress: false,
      };
    case COMPANIES_CREATE:
      return { ...state, errorMessage: null, inProgress: false };
    case COMPANIES_EDIT:
      return { ...state, errorMessage: null, inProgress: false };
    case COMPANIES_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    case COMPANIES_CHANGE_ACTIVE_FILTER_STATUS:
      return {
        ...state,
        filters: state.filters.map((filter) => {
          if (filter.propertyName === action.payload.propertyName) {
            filter.isActive = !filter.isActive;
          }
          return filter;
        }),
      };

    case COMPANY_DELETE_CONTACTS:
      const contacts = { ...state.contacts };
      delete contacts[action.payload.id];
      return {
        ...state,
        contacts,
      };
    case COMPANY_GET_CONTACTS:
      return {
        ...state,
        contacts: action.payload.reduce(
          (rx, el) => ({
            ...rx,
            [el.id]: el,
          }),
          {}
        ),
      };
    case COMPANY_EDIT_CONTACT:
    case COMPANY_CREATE_CONTACT:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          [action.payload.id]: action.payload,
        },
      };
    case COMPANIES_SHOW:
      return {
        ...state,
        currentCompany: action.payload,
        errorMessage: null,
        inProgress: false,
      };
    default:
      return state;
  }
}
